export default __webpack_public_path__ + "static/image_09-b5b5558a1ce4c99e24f8b64ab1dc61b2.png";